import { Component } from "@angular/core";
import {
  AbstractControl,
  FormControl,
  ValidationErrors,
  Validator,
} from "@angular/forms";

import { AbstractControlAccessor } from "./abstract-control-accessor";

/**
 * Base class for form controls that implement ControlValueAccessor.
 * Besides extending and implementing abstract members,
 * one must also register the inheriting subclass as NG_VALUE_ACCESSOR provider.
 */
@Component({
  selector: "app-form-control-accessor",
  template: "",
})
export abstract class FormControlAccessor<T>
  extends AbstractControlAccessor<T>
  implements Validator
{
  protected abstract get formControl(): FormControl<T>;

  protected override get control(): AbstractControl<Partial<T>, T> {
    return this.formControl as AbstractControl<Partial<T>, T>;
  }

  //#region Validator implementation
  public validate(): ValidationErrors | null {
    return this.formControl.errors;
  }
  //#endregion Validator implementation
}
